<template>
  <div>
    <el-button
      type="primary"
      v-if="!getAuthShow()"
      @click="recoverHandle"
      :disabled="optionButtonFlag != true"
      >{{ labelText("Recover From This Version") }}</el-button
    >
    <el-button
      type="warning"
      v-if="!getAuthShow()"
      @click="addVerifyListHandle"
      :disabled="optionButtonFlag"
      :loading="addVerifyListLoading"
      >{{ labelText("Add Verify List") }}</el-button
    >
    <el-button
      type="success"
      v-if="!getAuthShow()"
      @click="saveHandle"
      :loading="saveLoading"
      :disabled="optionButtonFlag"
      >{{ labelText("Save") }}</el-button
    >
    <el-button
      type="danger"
      v-if="!getAuthShow()"
      @click="verifyHandle"
      :loading="verifyLoading"
      :disabled="optionButtonFlag"
      >{{ labelText("Verify") }}</el-button
    >
    <el-button
      type="primary"
      @click="previewHandle"
      :loading="previewPdfLoading"
      >{{ labelText("Preview PDF") }}</el-button
    >
    <el-button @click="backHomeClick">{{ labelText("Back Home") }}</el-button>
    <el-dialog
      :title="this.$t('confirm.tips')"
      :visible.sync="printViewDialogVisible"
      width="30%">
      <el-form ref="form" :model="printViewDialogForm" label-width="120px">
        <el-form-item :label="this.$t('confirm.print_option_label')">
        <el-checkbox-group v-model="printViewDialogForm.type">
          <el-checkbox :label="this.$t('confirm.cutomer_signature')" name="type" border></el-checkbox>
          <el-checkbox :label="this.$t('confirm.verifed_signature')" name="type" border></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="printViewDialogVisible = false">{{this.$t('confirm.cancel')}}</el-button>
        <el-button type="primary" @click="previewConfirmHandle()">{{this.$t('confirm.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import * as StructConvertUtils from "../../spec/config/structConvertUtils";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
import { apiServer } from "@/network/modules/detail-api";
import base from "@/common/base.js";
// import * as TemplateUtils from '../../template/index'

export default {
  props: {
    isPrintSignature: Boolean,
    pageStatus: {
      type: String,
      default: "Add",
    },
  },
  computed: {
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    optionButtonFlag() {
      return this.pageStatus === "Detail";
    },
    labelText() {
      return (label) => {
        let key = "action." + label;
        key = key.toLowerCase().replaceAll(" ", "_");
        return this.$t(key);
      };
    },
  },
  inject: ["getModulesDataMethod","getNotesConfigMethod","getCurrentDataMethod","getVersionInfoMethod","getShelflifeNumberMethod"],
  data() {
    return {
      printViewDialogForm: {
        type:[]
      },
      printViewDialogVisible:false,
      language: "EN",
      saveLoading: false,
      verifyLoading: false,
      addVerifyListLoading: false,
      previewPdfLoading: false,
    };
  },
  methods: {
    getAuthShow(){
      return base.getAuthShow();
    },
    // 保存按钮点击
    saveHandle() {
      let type = this.$route.query.type;
      this.saveLoading = true;
      this.$emit("save", (res) => {
        let params = this.getSaveData(res);

        apiServer.getDataByType(type, "saveOrUpdate", params, data => {
          // 保存成功后，如果当前是Add状态，通知父组件切换到Edit状态
          if (this.pageStatus === "Add") {
            this.$EventBus.$emit("pageStatusChange", "Edit");
          }
          this.$message({
            message: this.$t("confirm.save_success"),
            type: "success",
          });
          this.saveLoading = false;
          let language = this.getCurrentDataMethod().language;
          this.$router.replace({
            path: "/detail",
            query: {
              id: data.id,
              type: "spec",
              isCopy: "false",
              language: language,
            },
          });
          if (
            this.$route.query.isCopy == "true" ||
            this.$route.query.isCopy == true
          ) {
            setTimeout(() => {
              this.$router.go(-1);
            }, 200);
          }
        },err=>{
          console.info("saveHandle error",err);
          this.saveLoading = false;
        });
      });
    },
    getButtonTextByLanguage() {},
    addVerifyListHandle() {
      this.$confirm(this.$t("confirm.add_to_verify_list"), this.$t("confirm.tips"), {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        let type = this.$route.query.type;
        this.addVerifyListLoading = true;
        this.$emit("save", (res) => {
          // 检查 revisionData
          let revision = res.rev.revision[res.rev.revision.length - 1];
          console.info("revision:", revision);
          let msg = "";
          if (revision.revisionDate.length == 0) {
            msg = this.$t("confirm.no_revision_date");
          }else if (revision.requestedBy.length == 0) {
            msg = this.$t("confirm.requested_by_empty");
          } else if (revision.itemsRevised == 0) {
            msg = this.$t("confirm.items_revised_empty");
          } else if (revision.reason == 0) {
            msg = this.$t("confirm.reason_empty");
          }else if (revision.editedBy == 0) {
            msg = this.$t("confirm.edited_by_empty");
          }
          if (msg != "") {
            this.addVerifyListLoading = false;
            this.$message({
              type: "error",
              message: msg,
            });
            return;
          }

          let params = this.getSaveData(res);

          console.info("add v list:",params)
          apiServer.getDataByType(type, "addVerifyList", params, () => {
            this.$message({
              message: this.$t("confirm.save_success"),
              type: "success",
            });
            this.addVerifyListLoading = false;
          });
        });
      });
    },
    getSaveData(data) {
      let paramsId = "";
      const isCopy =
        this.$route.query.isCopy === "false"
          ? false
          : !!this.$route.query.isCopy;
      if (this.$route.query.id && !isCopy) {
        paramsId = this.$route.query.id;
      }else{
        
        if(data.rev.revision.length==0){
          data.rev.revision = [{
            approvedBy:"",
            editedBy: localStorage.getItem('loginUserNameKey'),
            isComplete: false,
            reason: "",
            requestedBy: "",
            revisedNotes: "",
            revisionDate: "",
          }]
        }else{
          data.rev.revision[0].editedBy= localStorage.getItem('loginUserNameKey')
        }
        
        console.info('data.rev.revision:',data.rev.revision)
      }

      // 从versionInfo获取正确的revNumber值
      const versionInfo = this.getVersionInfoMethod && this.getVersionInfoMethod();
      let revNumber = data.revNumber;
      if (versionInfo && versionInfo.revNumber) {
        revNumber = versionInfo.revNumber;
      }
      if(isCopy==true|| isCopy=='true'){
        revNumber = 0;
      }
      let shelflifeNumber = data.other_notes.shelflife_number;
      if(shelflifeNumber==undefined||shelflifeNumber==null||shelflifeNumber==''){
        shelflifeNumber = this.getShelflifeNumberMethod();
        data.other_notes.shelflife_number = shelflifeNumber;
      }
      let saveData = {
        id: paramsId,
        itemCode: data.base_info.item_code,
        productType: data.base_info.product_type,
        productName: data.base_info.product_name,
        productDescription: data.base_info.product_description,
        physicalProperties: data.base_info.physical_properties,
        countryOfOrigin: data.general_specification.country_of_origin,
        botanicalName: data.general_specification.botanical_name.toString(),
        shelflifeNumber: data.other_notes.shelflife_number,//this.getShelflifeNumberMethod(), // 从 inject 获取 shelflifeNumber
        revNumber: revNumber,
        verified_time: "",
        rev_number: revNumber,
        jsonValue: JSON.stringify(data),
      };

      console.info("data.base_info.item_code:",data.base_info.item_code)
      console.info("saveData===>:", saveData);
      return saveData;
    },
    verifyHandle() {
      // 检查当前记录是否已经有 verified 版本
      const currentData = this.getCurrentDataMethod();
      console.info("currentData:",currentData)
      if (currentData.verified === 1) {
        this.$message({
          type: "warning",
          message: this.$t("confirm.already_has_verify_version"),
        });
        return;
      }
      
      this.$confirm(this.$t("confirm.verify_tips"), this.$t("confirm.tips"), {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        // let data = this.getFormDataMethod();
        this.$emit("save", (data) => {
          // 检查 revisionData
          let revision = data.rev.revision[data.rev.revision.length - 1];
          console.info("revision:", revision);
          let msg = "";
          if (revision.requestedBy.length == 0) {
            msg = this.$t("confirm.requested_by_empty");
          } else if (revision.itemsRevised == 0) {
            msg = this.$t("confirm.items_revised_empty");
          } else if (revision.editedBy == 0) {
            msg = this.$t("confirm.edited_by_empty");
          } else if (revision.reason == 0) {
            msg = this.$t("confirm.reason_empty");
          }
          if (msg != "") {
            this.$message({
              type: "error",
              message: msg,
            });
            return;
          }
          console.info("verifyHandle");
          let userInfo = JSON.parse(localStorage.getItem("specUserInfo"));
          if (!userInfo || !userInfo.nickname) {
            this.$confirm(
              this.$t("confirm.userinfo_error") || "用户信息获取失败，请重新登录",
              this.$t("confirm.tips"),
              {
                confirmButtonText: this.$t("confirm.ok"),
                cancelButtonText: this.$t("confirm.cancel"),
                type: "warning",
              }
            ).then(() => {
              // 使用 Vue 的方式跳转到登录页
              this.$router.push({ path: '/login' });
            });
            return;
          }
          revision.isComplete = true;
          revision.approvedBy = userInfo.nickname;
          revision.verifyName = userInfo.nickname;
          revision.verifyTime = dayjs().format("YYYY-MM-DD HH:mm:ss");

          data.rev.revision[data.rev.revision.length - 1] = revision;
          let saveData = this.getSaveData(data);


          this.verifyLoading = true;
          this.verifyNewSpec(saveData);
        });
      });
    },
    verifyNewSpec(params) {
      console.info("verifyNewSpec params:", params);
      let api = "";
      params.verifiedListUser = localStorage.getItem("loginUserNameKey");
      params.verified_time = new Date();
      let language = this.getCurrentDataMethod().language;
      console.info("【VERIFY DEBUG】PARAMS:", params);
      if (language == "cn") {
        api = this.$api.handleSpec.verifyCnNewSpec(params);
      } else {
        api = this.$api.handleSpec.verifyNewSpec(params);
      }

      api
        .then(() => {
          this.verifyLoading = false;
          // this.loadDetailDataMethod();
          this.$message({
            type: "success",
            message: "Update Success",
          });
        })
        .catch((err) => {
          this.verifyLoading = false;
          console.log(err);
        });
    },
    // 预览打印
    previewHandle() {
    console.info("this.pageStatus:",this.pageStatus)
      if (this.pageStatus === "Detail") {
        this.printViewDialogVisible = true;
      } else {
        this.previewHandleAction(this.pageStatus, false, false);
      }
      
    },
    previewConfirmHandle(){
      this.printViewDialogVisible = false;
      let customerSignatureSelected = this.printViewDialogForm.type.includes(this.$t('confirm.cutomer_signature'));
      let verifiedSignatureSelected = this.printViewDialogForm.type.includes(this.$t('confirm.verifed_signature'));
      this.previewHandleAction('Detail', customerSignatureSelected, verifiedSignatureSelected);
    },
    previewHandleAction(pageStatus, cutomer_signature, verifed_signature) {
      this.$emit("save", (res) => {
        let saveData = this.getSaveData(res);

        let versionNumber = "";
        let previewPdf = true; //编辑状态为 true
        if (pageStatus === "Detail") {
          previewPdf = false;
          // 在这里，我们需要从父组件或路由获取 currentTabName 和 revNumber，而不是 localStorage
          // 为了简化，暂时假设这些信息可以通过 prop 传递或者在父组件中处理
          // 这里暂时不修改 versionNumber 和 saveData.rev_number 的逻辑，因为这需要更多的上下文信息
        }
        // Notes相关逻辑，如果需要，请确保数据通过 prop 或 inject 传递
        const notesConfig = this.getNotesConfigMethod();
        let isShowNote = notesConfig.additionalNotes.is_show_note;
        const jsonValue = JSON.parse(saveData.jsonValue);
        jsonValue.other_notes.is_show_note = isShowNote;
        // jsonValue.other_notes.notes ;
        // TODO:处理英文版和中文版
        // let arrNotes = [];
        // if(notesConfig.additionalNotes.note1){
        //   arrNotes.push(notesConfig.additionalNotes.note1);
        // }
        // if(notesConfig.additionalNotes.note2){
        //   arrNotes.push(notesConfig.additionalNotes.note2);
        // }
        // if(notesConfig.additionalNotes.note3){
        //   arrNotes.push(notesConfig.additionalNotes.note3);
        // }
        
        // jsonValue.other_notes.notes = arrNotes;
        let queryType = this.$route.query.type;
        if(queryType == "spec"){
          jsonValue.other_notes.notes = notesConfig.specNoteArr
            .filter(note => !note.includes('可选打印'))
            .map(note => note.replace(/\*/g, ''));
        }
        // jsonValue.other_notes.notes = this.aditional.specNoteArr;
        console.info("arrNotes:",jsonValue.other_notes.notes)
        saveData.jsonValue = JSON.stringify(jsonValue);
        console.info("isShowNote33:",isShowNote)
        // 从 getContentByLanguageAndType 获取默认注释
        // 从 currentData 获取语言
        const currentData = this.getCurrentDataMethod();
        let language = currentData.language ? currentData.language.toLowerCase() : 'en';
        // 确保语言参数正确映射
        if (language === "cn" || language === "zh") {
          language = "cn";
        } else {
          language = "en";
        }
        
        //预览后端需要的字段为 json_value
        // let printTitle = JSON.parse(saveData.jsonValue).base_info.print_title;

        saveData.json_value = saveData.jsonValue;
        saveData.verified_time = this.getCurrentDataMethod().verifiedTime;
        delete saveData.jsonValue;

        let languageType = "US";
        let lang = this.getCurrentDataMethod().language.toLocaleLowerCase();
        
        if (lang == "cn" || lang == "zh") {
          languageType = "China";
        }
        
        let file_name =
          saveData.productName.replaceAll("%", "") +
          "_" +
          saveData.itemCode +
          "_" +
          versionNumber;
        // 文件名处理，防止非法字符和不可存储的形式
        file_name = file_name.replace(/[:]/g, " to "); // 冒号替换
        file_name = file_name.replace(/\s+/g, "_"); // 空格全部替换为下划线
        // 移除常见文件系统非法字符
        file_name = file_name.replace(/[%<>:"/\\|?*\t]/g, "");
        // 进一步移除多余下划线（如连续的下划线）
        file_name = file_name.replace(/_+/g, "_");
        // 去除首尾下划线
        file_name = file_name.replace(/^_+|_+$/g, "");

        if (previewPdf) {
          if (languageType == "China") {
            file_name = "(Preview 中文 Spec)" + file_name;
          } else {
            file_name = "(Preview Spec)" + file_name;
          }
        } else {
          if (languageType == "China") {
            file_name = "(中文 Spec)" + file_name;
          } else {
            file_name = "(Spec)" + file_name;
          }
        }
        
        let params = {
          language: languageType,
          data: saveData,
          cutomer_signature: cutomer_signature,
          verifed_signature: verifed_signature,
          preview_pdf: previewPdf,
          file_name: file_name,
          response_type: "text"
        };

        this.previewServer(params);
      });
    },
    previewServer(params) {
      this.previewPdfLoading = true;
      this.$axios
        .post("https://spec.dracoherbs.com/flask/generate_spec", params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.previewPdfLoading = false;
          let fileUrl =
            "https://spec.dracoherbs.com/download/" + response.data.file_name;
          setTimeout(function () {
            window.open(fileUrl);
          }, 200);
        })
        .catch((error) => {
          this.previewPdfLoading = false;
          console.error(error);
        });
    },
    backHomeClick() {
      window.history.go(-1);
    },
    recoverHandle() {
      let msg = "Are you sure to restore from this version?";
      let tipsText = "Tips";
      let okText = "OK";
      let cancelText = "Cancel";
      if (this.language == "CN") {
        msg = "您确定要从这个版本还原吗?";
        tipsText = "温馨提示";
        okText = "确定";
        cancelText = "取消";
      }
      this.$confirm(msg, tipsText, {
        confirmButtonText: okText,
        cancelButtonText: cancelText,
        type: "warning",
      }).then(() => {
        this.loadRecoverDataMethod();
      });
    },
  },
  created() {
    // this.language = localStorage.getItem("language"); // 语言应通过 prop 或 inject 获取
  },
};
</script>